import styled from 'styled-components'

const Heading = styled.h1`
  a {
    display: inline-block;
    padding: 0 12px;
  }
`

export default Heading
